import ReactDOM from 'react-dom/client'
import { buildPagedURL, setFetched } from 'reduxes/slices/api/actions'
import apiRoutes from 'routes/admin_api_routes.json'

import { makeActionCreator } from '../../util/make_action_creator'
import { handleApiError } from '../../util/parse_server_error'

export const SET_FILTER = 'SET_FILTER'
export const setFilter = makeActionCreator(
  SET_FILTER,
  'key',
  'filter',
  'replaceState',
)

export const SET_MATCHES = 'SET_MATCHES'
// eslint-disable-next-line
// @ts-ignore
export const setMatches = (key, { matches, hasMore, replaceState = false }) => {
  return {
    type: SET_MATCHES,
    key,
    matches,
    hasMore,
    replaceState,
  }
}

export type PagingState = {
  after?: number | null
  before?: number | null
  hasMoreAfter?: boolean
  hasMoreBefore?: boolean
}

export const INITIAL_PAGING_STATE = {
  after: undefined,
  before: undefined,
  hasMoreAfter: undefined,
  hasMoreBefore: undefined,
  showAfter: undefined,
  showBefore: undefined,
}

export const SET_PAGING = 'SET_PAGING'
export const setPagingFactory =
  (primaryKey: string) =>
  (pagingState: PagingState, ...subKeys: (number | string)[]) => {
    return {
      type: SET_PAGING,
      keys: [primaryKey, ...subKeys],
      pagingState,
    }
  }

export const setTopicsPaging = setPagingFactory('group_chats')
export const setLiveChatsPaging = setPagingFactory('live_chats')

const SEARCH_INITIAL_FETCH_SIZE = 50

// eslint-disable-next-line
// @ts-ignore
export function fetchSearchResult(filter, afterDate = null) {
  // eslint-disable-next-line
  // @ts-ignore
  return function (axios, dispatch) {
    const url = apiRoutes.admin_api_v1_search_index.path
    const fetchSize = afterDate ? null : SEARCH_INITIAL_FETCH_SIZE
    const urlPaged = buildPagedURL(url, {
      after: afterDate,
      before: new Date(),
      limit: fetchSize,
      filter: filter,
    })

    return axios()
      .get(urlPaged)
      .then(
        (result: any) => {
          dispatch(
            // eslint-disable-next-line
            // @ts-ignore
            setMatches('search', {
              matches: result.data.matches,
              replaceState: true,
            }),
          )
          dispatch(setFetched('search', result.data.records))
          return Promise.resolve(result)
        },
        (result: any) => {
          // eslint-disable-next-line
          // @ts-ignore
          handleApiError({
            dispatch,
            result,
            path: url,
          })
          return Promise.reject(result)
        },
      )
  }
}

export const SET_TIMELINES_PAGING = 'SET_TIMELINES_PAGING'
export const setTimelinesPaging = (
  // eslint-disable-next-line
  // @ts-ignore
  topicId,
  newState = {
    after: undefined,
    before: undefined,
    hasMore: undefined,
    /* cachedBefore: used to reduce the total page size persisted to local storage.
    Persisting the paging to local storage makes content available instantly */
    cachedBefore: undefined,
  },
) => {
  return {
    type: SET_TIMELINES_PAGING,
    topicId,
    newState,
  }
}
